export const removeMaliciousHTML = (html: string) => {
  if (!html) return ''

  // Remove script tags and their contents
  html = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')

  // Remove onclick and similar event handlers
  html = html.replace(/ on\w+="[^"]*"/g, '')
  html = html.replace(/ on\w+='[^']*'/g, '')

  // Remove javascript: URLs
  html = html.replace(/javascript:[^\s"']+/gi, '')

  // Remove data: URLs
  html = html.replace(/data:[^\s"']+/gi, '')

  // Remove iframe tags
  html = html.replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')

  // Remove object/embed tags
  html = html.replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, '')
  html = html.replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, '')

  return html
}
